import { SampleInfo } from './Utils';

export async function fetch_data(type: string, dataset: string, n_shards: number) {
  let result: Array<SampleInfo>;
  // if (process.env.NODE_ENV === 'development') {
  if (false) {
    result = [
      {
        info: {text: 'foo'},
        samples: {
          policy1: 'A sample from policy 1',
          policy2: 'A sample from policy 2',
        },
      },
      {
        info: {text: 'bar'},
        samples: {
          policy1: 'Another sample from policy 1',
          policy2: 'Another sample from policy 2',
        },
      },
    ];
  } else {
    try {
      let shard = Math.floor(Math.random() * n_shards);
      const response = await fetch(`data/${type}.${dataset}.${shard}.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        // body: JSON.stringify({
        // }),
      });
      result = (await response.json());
    } catch (e) {
      alert(e);
      throw e
    }
  }
  return {
    id: Math.random(),
    results: result as any,
    dataset: dataset,
  };
}

